import React, {useEffect, useRef, useState, useCallback} from 'react';
import {debounce} from 'throttle-debounce';

import './style.scss';

/**
 * 
 * @param {string} eventKey
 * @param {string} suggestionsName Type of suggestion from constant. Default: company
 * @param {number} startLength Start lenght of input string for get suggestion. Default: 3
 * @param {number} delay Delay for debounce function. Default: 400
 * @param {function} apiCallback Api callback for get suggestions. Required
 * @param {DOMElement} children
 * @returns
 */
const CInputSuggestions = ({
    $locale,
    startLength = 3,
    delay = 400,
    suggestionsList = [],
    hasInputValue,
    apiCallback,
    onSelect,
    children,
}) => {
    const [suggestions, setSuggestions] = useState([]);
    const [isListVisible, setListVisible] = useState(false);
    const currentRef = useRef(null);

    useEffect(() => {
        if (!!suggestionsList.length || !hasInputValue) {
            setSuggestions(suggestionsList);
            setListVisible(true);
        }
    }, [suggestionsList, hasInputValue]);

    useEffect(() => {
        const element = currentRef.current.querySelector('input');

        element.addEventListener('input', handleInput);

        return () => {
            element.removeEventListener('input', handleInput);
        };
    }, [currentRef]);

    const handleGetSuggestions = useCallback(
        debounce(delay, getSuggestions)
    , []);

    function handleInput(event) {
        const value = event.target?.value ?? null;

        if (value?.length < startLength) return;

        handleGetSuggestions(value);
        setListVisible(true);
    }

    function handleSuggestSelect(suggest) {
        onSelect(suggest);
        setListVisible(false);
    }

    async function getSuggestions(query) {
        const data = await apiCallback(query);
        setSuggestions(data || []);
    }

    return (
        <div
            ref={currentRef}
            className="c-input-suggestions"
        >
            {children}
            {
                isListVisible &&
                <div className="c-input-suggestions-content">
                    {
                        !!suggestions.length
                        ? <ul className="c-input-suggestions-list container-scroll">
                            {
                                suggestions.map((name, index) => (
                                    <li
                                        key={index}
                                        className="c-input-suggestions-item"
                                        onClick={() => handleSuggestSelect(name)}
                                    >
                                        {name}
                                    </li>
                                ))
                            }
                        </ul>
                        : <p>{$locale.get('label.find.nothing')}</p>
                    }
                </div>
            }
        </div>
    )
};

export default CInputSuggestions;
